export function discountPercentageCalculatedByTaxes(discountAmount: number, amount: number, taxes: number): number {
  if (discountAmount && amount) {
    return Math.round((discountAmount / (amount + (taxes || 0))) * 100);
  } else {
    return 0;
  }
}

export function discountPercentageCalculatedByTotal(discountAmount: number, total: number): number {
  if (discountAmount && total) {
    return Math.round((discountAmount / (total + discountAmount)) * 100);
  } else {
    return 0;
  }
}
